module.exports = __webpack_public_path__ + "static/media/icon_runs_the_world.b7abf494.png";